import { useQuery, useSubscription } from "@apollo/react-hooks";
import { GET_NOT_AUTHORIZED_WO_EXAMINER_LIST } from "my-time/graphql/queries";
import { MY_TIME_REQUESTS_SUBSCRIPTION } from "my-time/graphql/subscriptions";

export const useMyTimeNotAuthorizedWoExaminerList = () => {
  const { data, loading, error, refetch } = useQuery(GET_NOT_AUTHORIZED_WO_EXAMINER_LIST, {
    fetchPolicy: "cache-and-network",
  });

  useSubscription(MY_TIME_REQUESTS_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.notAuthorizedListWoExaminer || [],
    loading,
    error,
    refetch,
  };
};

export default useMyTimeNotAuthorizedWoExaminerList;
